const Title = ({ title, children }) => {
  document.title = title
  return children
}

export default Title